<template>
  <div id="pop">
    <button
      type="button"
      class="btn btn-primary pull-right"
      @click="showModal"
    >
      {{ text }}
    </button>

    <Modal
      v-if="isModalVisible"
      :next="next"
      :sign="sign"
      :accept="accept"
      :name="name"
      :text="text"
      @close="closeModal"
    />
  </div>
</template>

<script>
import { defineComponent, ref } from 'vue';
import Modal from './components/modal.vue';

export default defineComponent({
  components: { Modal },
  props: ["name", "next", "text", "sign", "accept"],
  setup() {
    const isModalVisible = ref(false);

    const showModal = () => {
      isModalVisible.value = true;
    };

    const closeModal = () => {
      isModalVisible.value = false;
    };

    return {
      isModalVisible,
      showModal,
      closeModal,
    };
  },
});
</script>
